<template>
    <div class="calendar-row" :class="{'row-extended': technician.extended}">
        <calendar-technician-cell :technician="technician"
                                  :extended="technician.extended"
                                  @extend="extendRow">
        </calendar-technician-cell>
        <template v-for="(technicianDay, index) in technician.days">
            <calendar-absence-cell v-if="technicianDay.absences.length > 0 && !hasInterventionsOrElements(technicianDay.plannings) && !hasReunion(technicianDay.plannings)"
                                   :key="index"
                                   :extended="technician.extended"
                                   :day="{ weekNumber: weekNumber, date: technicianDay.day }"
                                   :absences="technicianDay.absences"
                                   :type="technicianDay.absences[(technicianDay.absences.length - 1)].absence_type_id"
                                   :technician="{ id: technician.id, fullName: technician.full_name }"
                                   @update-cell="$emit('update-cell', $event)">
            </calendar-absence-cell>
            <calendar-cell v-else :key="index"
                           :plannings="technicianDay.plannings"
                           :extended="technician.extended"
                           :isConflict="technicianDay.isConflict"
                           :day="{ weekNumber: weekNumber, date: technicianDay.day }"
                           :absences="technicianDay.absences"
                           :technician="{ id: technician.id, fullName: technician.full_name }"
                           @update-cell="$emit('update-cell', $event)">
            </calendar-cell>
        </template>
    </div>
</template>

<script>
import CalendarTechnicianCell from "@/pages/Planning/Calendar/components/calendar/CalendarTechnicianCell";
import CalendarCell from "@/pages/Planning/Calendar/components/calendar/CalendarCell";
import CalendarAbsenceCell from "@/pages/Planning/Calendar/components/calendar/CalendarAbsenceCell";
export default {
    name: "CalendarRowTechnician",
    components: {
        CalendarTechnicianCell, CalendarCell, CalendarAbsenceCell
    },
    props: {
        technician: Object,
        weekNumber: Number
    },
    methods: {
        extendRow() {
            this.technician.extended = !this.technician.extended
        },
        hasInterventionsOrElements(plannings) {
            return plannings.filter(planningable => {
                return planningable.planningable_type && (planningable.planningable_type.includes('Intervention') || planningable.planningable_type.includes('Element'))
            }).length > 0
        },
        hasReunion(plannings) {
            return plannings.filter(planningable => {
                return planningable.absence_type_id && planningable.absence_type_id === 7
            }).length > 0
        }
    }
}
</script>

<style scoped>

</style>
